import { Box, ButtonBase } from '@mui/material';
import { useCallback } from 'react';
import { classifyImageRequest } from '../../../../../providers/legacy/datasources/sessionDataSource';
import { currentImageIdSelector, selectedRubricSelector } from '../../../../../core/legacy/selectors/streetView';
import { CLASSIFICATION_IA_RUBRIC_CODE } from './classificationIaRubricCode';
import { useAppSelector } from '../../../../../types';
import type { Reference } from '../../../../../core/domain/Roaddata';

const ClassificationOverlay = () => {
    const selectedRubric = useAppSelector(selectedRubricSelector);
    const currentImageId = useAppSelector(currentImageIdSelector);

    const isClassificationIA = selectedRubric?.code === CLASSIFICATION_IA_RUBRIC_CODE;

    const handleClassify = useCallback(
        async (reference: Reference) => {
            if (!currentImageId || !selectedRubric) return;
            try {
                await classifyImageRequest({
                    imageId: currentImageId,
                    rubricId: selectedRubric.id,
                    referenceKey: reference.key,
                });
            } catch (e) {
                console.error(e);
            }
        },
        [currentImageId, selectedRubric],
    );

    if (!isClassificationIA || !selectedRubric?.references?.length) return null;

    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: 24,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                zIndex: 10,
                pointerEvents: 'none',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    px: 2.5,
                    py: 1.25,
                    background: 'rgba(0, 0, 0, 0.45)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    borderRadius: '50px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    pointerEvents: 'auto',
                }}
            >
                {selectedRubric.references.map((reference) => (
                    <ButtonBase
                        key={reference.key}
                        onClick={() => handleClassify(reference)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            px: 1.5,
                            py: 0.75,
                            borderRadius: '30px',
                            color: '#fff',
                            fontWeight: 600,
                            fontSize: '13px',
                            letterSpacing: '0.02em',
                            transition: 'background 0.15s',
                            '&:hover': {
                                background: 'rgba(255,255,255,0.12)',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                backgroundColor: reference.color,
                                boxShadow: `0 0 6px ${reference.color}`,
                                flexShrink: 0,
                            }}
                        />
                        {reference.name}
                    </ButtonBase>
                ))}
            </Box>
        </Box>
    );
};

export default ClassificationOverlay;
